import { formatMktTyp, formatNumber, formatDecimalPlus, formatFixed } from 'Util';
import React, { useEffect, useState } from 'react';
import { checkAttentionStock, removeAttentionStock, addAttentionStock } from 'Request/login'

function renderingRate(prev, cur) {
  if (prev !== 0) {
    const rate = (cur/prev-1)*100;
    if (rate > 0) {
      return (
        <div className="rate up"><i>▲</i> {formatNumber(cur - prev)} ({formatDecimalPlus(rate, 2)}%)</div>
      )
    } else if (rate < 0) {
      return (
        <div className="rate down"><i>▼</i> {formatNumber(cur - prev)} ({formatDecimalPlus(rate, 2)}%)</div>
      )
    } else {
      return (
        <div className="rate">- (0.00%)</div>
      )
    }
  }
}

function renderingUpDown(data) {
  if (data) {
    const val = data.COMMENT;
    if (val === 1) {
      return (
        <div className="flex">
          <div className="text"><span className="txt_red">상승</span>하고 있습니다.</div>
        </div>
      )
    } else if (val === -1) {
      return (
        <div className="flex">
          <div className="text"><span className="txt_blue">하락</span>하고 있습니다.</div>  
        </div>
      )
    } else if (val === 0) {
      return (
        <div className="flex">
          <div className="text"><span className="txt_gray">횡보</span>하고 있습니다.</div>  
        </div>
      )
    } else {
      return (
        <div className="flex">
          <div className="none">
            <div className="none_txt"><strong>학습</strong> 하고 있습니다.</div>
          </div>
        </div>
      )
    }
  } else {
    return (
      <div className="flex">
        <div className="none">
          <div className="none_txt"><strong>학습</strong> 하고 있습니다.</div>
        </div>
      </div>
    )
  }
}

function renderingHighLow(score, step) {
  score = formatFixed(score, 0);
  if (step === 1) {
    return (
      <div className="grade grade3">
        <div className="num">{score}점</div>
        <div className="txt"><em>매우 낮은</em> 수준입니다.</div>
      </div>
    )
  } else if (step === 2) {
    return (
      <div className="grade grade3">
        <div className="num">{score}점</div>
        <div className="txt"><em>낮은</em> 수준입니다.</div>
      </div>
    )
  } else if (step === 3) {
    return (
      <div className="grade grade2">
        <div className="num">{score}점</div>
        <div className="txt"><em>보통</em> 수준입니다.</div>
      </div>
    )
  } else if (step === 4) {
    return (
      <div className="grade grade1">
        <div className="num">{score}점</div>
        <div className="txt"><em>높은</em> 수준입니다.</div>
      </div>
    )
  } else if (step === 5) {
    return (
      <div className="grade grade1">
        <div className="num">{score}점</div>
        <div className="txt"><em>높은</em> 수준입니다.</div>
      </div>
    )
  }
}

function renderingConsensusRate(rate1, rate2) {
  return (
    <div className="rate">
      <span className={rate1 > 0 ? "up" : rate1 < 0 ? 'down' : ''}>{formatDecimalPlus(rate1, 1)}%</span>
      <span> ~ </span>
      <span className={rate2 > 0 ? "up" : rate2 < 0 ? 'down' : ''}>{formatDecimalPlus(rate2, 1)}%</span>
      {rate1 > 0 && rate2 > 0 && <span className="status positive" style={{fontSize:'12px', color:'#F15050'}}> 상승 여력</span>}
      {rate1 < 0 && rate2 < 0 && <span className="status negative" style={{fontSize:'12px', color:'#3582F5'}}> 하락 위험</span>}
      {rate1 < 0 && rate2 > 0 && <span className="status neutral" style={{fontSize:'12px', color:'#1D2A53'}}> 적정 수준</span>}
    </div>
  )
}

const Info = ({ data }) => {
  const [isLiked, setIsLiked] = useState(false);

  // 최초 마운트 시 관심 여부 확인
  useEffect(() => {
    if (data.user_id && data.TICKER) {
      checkAttentionStock(data.user_id, data.TICKER).then(res => {
        setIsLiked(res.attention);
      });
    }
  }, [data.user_id, data.TICKER]);

  const toggleLike = async () => {
    try {
      if (isLiked) {
        await removeAttentionStock(data.user_id, data.TICKER);
      } else {
        await addAttentionStock(data.user_id, data.TICKER, data.STK_TYP, data.CTR_TYP);
      }
      setIsLiked(!isLiked);
    } catch (e) {
      console.error('관심종목 토글 실패:', e);
    }
  };

	return (
    <div className="content1">
      <div className="info">
        { data && data.info &&
        <div className="flex">
          <div className="stock">{formatMktTyp(data.info.MKT_TYP)} | {data.info.WI26_NM}</div>
          <div className="name">
            {data.TICKER_NAME} <span>({data.TICKER})</span>
          </div>
        </div>
        }
        { data && data.siseInfo &&
        <div className="flex">
          <div className="price"><strong>{formatNumber(data.siseInfo.trdPrc)}</strong><em>원</em></div>
          {renderingRate(data.siseInfo.prevddClsprc, data.siseInfo.trdPrc)}
        </div>
        }
      </div>
      <div className="box">
        <ul>
          <li className="big">
            <div className="flex">
              <div className="icon"><img src="/static/images/main3_box1.png" alt="" /></div>
              <div className="name">공정가치</div>
            </div>
            <div className="flex">
              { data.consensus.UPSIDE 
                ?
                <>
                  {renderingConsensusRate(data.consensus.MIN_FINLIT_UPSIDE, data.consensus.MAX_FINLIT_UPSIDE)}
                  <div className="price">{formatNumber(data.consensus.MIN_FINLIT_TARGET)}원 ~ {formatNumber(data.consensus.MAX_FINLIT_TARGET, 1)}원</div>
                </>
                :
                <div className="none">
                  <div className="none_cir"></div>
                  <div className="none_txt"><strong>학습</strong> 하고 있습니다.</div>
                </div>
              }
            </div>
          </li>
          <li className="small">
            <div className="flex">
              <div className="icon"><img src="/static/images/main3_box3.png" alt="" /></div>
              <div className="name">단기매매시그널</div>
            </div>
            {data && renderingUpDown(data.info)}
          </li>
          <li className="small">
            <div className="flex">
              <div className="icon"><img src="/static/images/main3_box2.png" alt="" /></div>
              <div className="name">투자매력도</div>
            </div>
            {data && renderingUpDown(data.att)}
          </li>
          <li className="big">
            <div className="flex">
              <div className="icon"><img src="/static/images/main3_box4.png" alt="" /></div>
              <div className="name">QAIS종합점수</div>
            </div>
            <div className="flex">
              { data && data.info &&
                renderingHighLow(data.info.SCORE, data.info.SCORE_STEP)
              }
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Info;
